import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const articles = [
  {
    titleKey: 'articles.article_1_title',
    descKey: 'articles.article_1_desc',
    image: 'https://readdy.ai/api/search-image?query=A%20minimal%20workspace%20with%20a%20laptop%20displaying%20a%20spreadsheet%20of%20product%20data%20next%20to%20a%20coffee%20cup%20on%20a%20clean%20white%20desk%20soft%20natural%20light%20modern%20office%20editorial%20photography%20warm%20neutral%20tones&width=600&height=400&seq=article-01&orientation=landscape',
    slug: '/allchinabuy-spreadsheet/',
  },
  {
    titleKey: 'articles.article_2_title',
    descKey: 'articles.article_2_desc',
    image: 'https://readdy.ai/api/search-image?query=A%20close%20up%20of%20hands%20inspecting%20a%20sneaker%20quality%20checking%20stitching%20and%20sole%20on%20a%20clean%20white%20surface%20soft%20studio%20light%20minimalist%20product%20inspection%20editorial%20photography&width=600&height=400&seq=article-02&orientation=landscape',
    slug: '/how-to-read-qc-photos/',
  },
  {
    titleKey: 'articles.article_3_title',
    descKey: 'articles.article_3_desc',
    image: 'https://readdy.ai/api/search-image?query=A%20row%20of%20cardboard%20shipping%20boxes%20with%20labels%20stacked%20neatly%20in%20a%20clean%20warehouse%20soft%20natural%20light%20minimalist%20logistics%20editorial%20photography%20warm%20neutral%20tones&width=600&height=400&seq=article-03&orientation=landscape',
    slug: '/shipping-methods-compared/',
  },
  {
    titleKey: 'articles.article_4_title',
    descKey: 'articles.article_4_desc',
    image: 'https://readdy.ai/api/search-image?query=A%20minimal%20shield%20and%20lock%20security%20icon%20on%20a%20soft%20pastel%20gradient%20background%20clean%20modern%20digital%20safety%20concept%20editorial%20illustration%20high%20detail&width=600&height=400&seq=article-04&orientation=landscape',
    slug: '/is-allchinabuy-safe/',
  },
  {
    titleKey: 'articles.article_5_title',
    descKey: 'articles.article_5_desc',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20warehouse%20with%20cardboard%20boxes%20and%20a%20laptop%20showing%20an%20order%20tracking%20dashboard%20soft%20natural%20light%20minimalist%20clean%20editorial%20photography%20warm%20neutral%20tones&width=600&height=400&seq=article-05&orientation=landscape',
    slug: '/allchinabuy-review/',
  },
  {
    titleKey: 'articles.article_6_title',
    descKey: 'articles.article_6_desc',
    image: 'https://readdy.ai/api/search-image?query=A%20neat%20stack%20of%20sealed%20cardboard%20shipping%20boxes%20with%20labels%20in%20a%20bright%20clean%20warehouse%20soft%20natural%20light%20minimalist%20logistics%20editorial%20photography&width=600&height=400&seq=article-06&orientation=landscape',
    slug: '/allchinabuy-shipping-cost/',
  },
  {
    titleKey: 'articles.article_7_title',
    descKey: 'articles.article_7_desc',
    image: 'https://readdy.ai/api/search-image?query=A%20clean%20modern%20warehouse%20interior%20with%20organized%20shelves%20of%20packages%20and%20a%20worker%20scanning%20a%20box%20soft%20natural%20light%20minimalist%20logistics%20editorial%20photography%20high%20detail&width=600&height=400&seq=article-07&orientation=landscape',
    slug: '/allchinabuy-warehouse/',
  },
  {
    titleKey: 'articles.article_8_title',
    descKey: 'articles.article_8_desc',
    image: 'https://readdy.ai/api/search-image?query=A%20minimal%20scene%20with%20a%20discount%20tag%20icon%20and%20shopping%20bags%20on%20a%20clean%20pastel%20background%20soft%20natural%20light%20editorial%20ecommerce%20photography%20warm%20neutral%20tones&width=600&height=400&seq=article-08&orientation=landscape',
    slug: '/allchinabuy-coupon/',
  },
  {
    titleKey: 'articles.article_9_title',
    descKey: 'articles.article_9_desc',
    image: 'https://readdy.ai/api/search-image?query=A%20secure%20online%20shopping%20concept%20with%20a%20shield%20and%20shopping%20cart%20on%20a%20clean%20light%20background%20soft%20natural%20light%20minimalist%20editorial%20illustration%20warm%20neutral%20tones&width=600&height=400&seq=article-09&orientation=landscape',
    slug: '/is-allchinabuy-legit/',
  },
  {
    titleKey: 'articles.article_10_title',
    descKey: 'articles.article_10_desc',
    image: 'https://readdy.ai/api/search-image?query=A%20small%20business%20owner%20organizing%20products%20on%20shelves%20in%20a%20bright%20clean%20shop%20soft%20natural%20light%20minimalist%20editorial%20photography%20warm%20neutral%20tones%20high%20detail&width=600&height=400&seq=article-10&orientation=landscape',
    slug: '/allchinabuy-seller-guide/',
  },
  {
    titleKey: 'articles.article_11_title',
    descKey: 'articles.article_11_desc',
    image: 'https://readdy.ai/api/search-image?query=A%20person%20using%20a%20laptop%20to%20browse%20an%20online%20shopping%20website%20with%20product%20images%20soft%20natural%20light%20minimalist%20workspace%20editorial%20photography%20warm%20neutral%20tones&width=600&height=400&seq=article-11&orientation=landscape',
    slug: '/how-to-find-products/',
  },
  {
    titleKey: 'articles.article_12_title',
    descKey: 'articles.article_12_desc',
    image: 'https://readdy.ai/api/search-image?query=A%20person%20unboxing%20a%20cardboard%20package%20with%20clothing%20items%20inside%20on%20a%20clean%20desk%20soft%20natural%20light%20minimalist%20lifestyle%20editorial%20photography%20warm%20neutral%20tones&width=600&height=400&seq=article-12&orientation=landscape',
    slug: '/allchinabuy-buying-guide/',
  },
  {
    titleKey: 'articles.article_13_title',
    descKey: 'articles.article_13_desc',
    image: 'https://readdy.ai/api/search-image?query=A%20calculator%20and%20shipping%20boxes%20on%20a%20clean%20desk%20with%20a%20laptop%20showing%20a%20cost%20estimate%20soft%20natural%20light%20minimalist%20editorial%20photography%20warm%20neutral%20tones&width=600&height=400&seq=article-13&orientation=landscape',
    slug: '/allchinabuy-shipping-calculator/',
  },
  {
    titleKey: 'articles.article_14_title',
    descKey: 'articles.article_14_desc',
    image: 'https://readdy.ai/api/search-image?query=A%20person%20looking%20at%20a%20laptop%20with%20a%20thoughtful%20expression%20while%20shopping%20online%20soft%20natural%20light%20minimalist%20lifestyle%20editorial%20photography%20warm%20neutral%20tones&width=600&height=400&seq=article-14&orientation=landscape',
    slug: '/common-allchinabuy-mistakes/',
  },
];

export default function ArticleSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = (slug: string) => {
    if (slug.startsWith('http')) {
      window.open(slug, '_blank', 'noopener,nofollow');
    } else {
      navigate(slug);
    }
  };

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3">
              {t('articles.title')}
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              {t('articles.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {articles.map((article, index) => (
              <button
                key={index}
                onClick={() => handleClick(article.slug)}
                className="group text-left bg-white rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full h-40 md:h-48 overflow-hidden">
                  <img
                    src={article.image}
                    alt={t(article.titleKey)}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {t(article.titleKey)}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3 mb-3">
                    {t(article.descKey)}
                  </p>
                  <span className="inline-flex items-center gap-1 text-xs md:text-sm font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                    {t('articles.read_more')}
                    <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}